export enum ESubSection {
    SubSection3 = 1,
    SubSection4 = 2,
    SubSection3and4 = 3
}